import utils from '@/plugins/utils'

const agraRoutes = [
  {
    path: '/agra/login',
    name: 'agraLogin',
    component: () => import('@/views/agra/login/Login.vue'),
    meta: { layout: 'auth', sidebar: false, footer: false }
  },
  {
    path: '/agra/loginmap',
    name: 'agraLoginMap',
    component: () => import('@/views/agra/login/Loginmap.vue'),
    meta: { layout: 'auth', sidebar: false, footer: false }
  },
  {
    path: '/agra/register',
    name: 'agraRegister',
    component: () => import('@/views/agra/login/Register.vue'),
    meta: { layout: 'auth', sidebar: false, footer: false }
  },
  {
    path: '/agra',
    redirect: '/agra/mysurvey',
    meta: { layout: 'app', sidebar: false, footer: true, authorize: ['member', 'admin'] }
  },
  {
    path: '/agra/mysurvey',
    name: 'agraMySurvey',
    component: () => import('@/views/agra/MySurvey.vue'),
    meta: { layout: 'app', sidebar: false, footer: false, authorize: ['member', 'admin'] }
  },
  
  // waterQualityRoutes
  {
    path: '/agra/waterquality/survey/:id?/:mode?',
    name: 'waterQualitySurvey',
    props: true,
    component: () => import('@/views/agra/survey/waterQuality/WaterQualitySurvey.vue'),
    meta: { layout: 'app', sidebar: false, footer: false, authorize: ['member', 'admin'], systemName: 'agra', screenId: [utils.screenId.waterQuality], permissionKey: ['isEdit']  }
  },
  {
    path: '/agra/waterquality/myanswers',
    name: 'waterQualityMyAnswers',
    component: () => import('@/views/agra/survey/waterQuality/WaterQualityMyList.vue'),
    meta: { layout: 'app', sidebar: false, footer: false, authorize: ['member', 'admin'], systemName: 'agra', screenId: [utils.screenId.waterQuality], permissionKey: ['isView'] }
  },
  {
    path: '/agra/waterquality/map',
    name: 'waterQualityMap',
    component: () => import('@/views/agra/survey/waterQuality/WaterQualityMap.vue'),
    meta: { layout: 'app', sidebar: false, footer: false, authorize: ['member', 'admin'], systemName: 'agra', screenId: [utils.screenId.waterQuality, utils.screenId.waterQualityAdmin], permissionKey: ['isView'] }
  },
  {
    // เลือกคำตอบเพื่อส่งตัวอย่าง
    path: '/agra/waterquality/sample/select',
    name: 'waterQualitySampleSelect',
    component: () => import('@/views/agra/survey/waterQuality/sample/WaterQualitySampleSelect.vue'),
    meta: { layout: 'app', sidebar: false, footer: false, authorize: ['member', 'admin'], systemName: 'agra', screenId: [utils.screenId.waterQualitySample], permissionKey: ['isEdit'] }
  },
  {
    // แสดงรายการแบบฟอร์มส่งตัวอย่าง
    path: '/agra/waterquality/sample/myanswers',
    name: 'waterQualitySampleMyAnswers',
    component: () => import('@/views/agra/survey/waterQuality/sample/WaterQualitySampleMyAnswers.vue'),
    meta: { layout: 'app', sidebar: false, footer: false, authorize: ['member', 'admin'], systemName: 'agra', screenId: [utils.screenId.waterQualitySample], permissionKey: ['isView'] }
  },
  {
    // ตอบแบบฟอร์มส่งตัวอย่าง
    path: '/agra/waterquality/sample/id/:id/:mode?',
    name: 'waterQualitySampleSurvey',
    props: true,
    component: () => import('@/views/agra/survey/waterQuality/sample/WaterQualitySampleSurvey.vue'),
    meta: { layout: 'app', sidebar: false, footer: false, authorize: ['member', 'admin'], systemName: 'agra', screenId: [utils.screenId.waterQualitySample, utils.screenId.waterQualitySampleAdmin], permissionKey: ['isEdit', 'isView'] }
  },

  // admin
  {
    path: '/agra/waterquality/answers',
    name: 'waterQualityAnswers',
    component: () => import('@/views/agra/survey/waterQuality/WaterQualityList.vue'),
    meta: { layout: 'app', sidebar: false, footer: false, authorize: ['admin'],  systemName: 'agra', screenId: [utils.screenId.waterQualityAdmin], permissionKey: ['isView'] }
  },
  {
    // เลือกคำตอบเพื่อส่งตัวอย่าง
    path: '/agra/waterquality/sample/selectlist',
    name: 'waterQualitySampleSelectList',
    component: () => import('@/views/agra/survey/waterQuality/sample/WaterQualitySampleSelectList.vue'),
    meta: { layout: 'app', sidebar: false, footer: false, authorize: ['admin'] }
  },
  {
    // แสดงรายการแบบฟอร์มส่งตัวอย่าง
    path: '/agra/waterquality/sample/answers',
    name: 'waterQualitySampleAnswers',
    component: () => import('@/views/agra/survey/waterQuality/sample/WaterQualitySampleAnswers.vue'),
    meta: { layout: 'app', sidebar: false, footer: false, authorize: ['admin'], systemName: 'agra', screenId: [utils.screenId.waterQualitySampleAdmin], permissionKey: ['isView'] }
  },
  {
    path: '/agra/waterquality/charts',
    name: 'waterQualityCharts',
    component: () => import('@/views/agra/survey/waterQuality/WaterQualityCharts.vue'),
    meta: { layout: 'app', sidebar: false, footer: false, authorize: ['admin'] }
  },
  // end admin

  // researcher
  {
    path: '/agra/waterquality/researcher/answers',
    name: 'waterQualityResearchAnswers',
    component: () => import('@/views/agra/survey/waterQuality/researcher/WaterQualityList.vue'),
    meta: { layout: 'app', sidebar: false, footer: false, authorize: ['member', 'admin'], systemName: 'agra', screenId: [utils.screenId.waterQualityResearcherAdmin], permissionKey: ['isView']  }
  },
  // end waterQualitySampleRoutes

  // soundMeasurementRoutes.
  {
    path: '/agra/soundmeasurement/survey/:id?',
    name: 'soundMeasurementSurvey',
    props: true,
    component: () => import('@/views/agra/survey/soundMeasurement/SoundMeasurementSurvey.vue'),
    meta: { layout: 'app', sidebar: false, footer: false, authorize: ['member', 'admin'], systemName: 'agra', screenId: [utils.screenId.soundMeasurement, utils.screenId.soundMeasurementAdmin], permissionKey: ['isEdit'] }
  },
  {
    path: '/agra/soundmeasurement/myanswers',
    name: 'soundMeasurementMyAnswers',
    component: () => import('@/views/agra/survey/soundMeasurement/SoundMeasurementMyList.vue'),
    meta: { layout: 'app', sidebar: false, footer: false, authorize: ['member', 'admin'], systemName: 'agra', screenId: [utils.screenId.soundMeasurement], permissionKey: ['isView'] }
  },
  {
    path: '/agra/soundmeasurement/map',
    name: 'soundMeasurementMap',
    component: () => import('@/views/agra/survey/soundMeasurement/SoundMeasurementMap.vue'),
    meta: { layout: 'app', sidebar: false, footer: false, authorize: ['member', 'admin'], systemName: 'agra', screenId: [utils.screenId.soundMeasurement, utils.screenId.soundMeasurementAdmin], permissionKey: ['isView'] }
  },

  // admin
  {
    path: '/agra/soundmeasurement/answers',
    name: 'soundMeasurementAnswers',
    component: () => import('@/views/agra/survey/soundMeasurement/SoundMeasurementList.vue'),
    meta: { layout: 'app', sidebar: false, footer: false, authorize: ['admin'], systemName: 'agra', screenId: [utils.screenId.soundMeasurementAdmin], permissionKey: ['isView'] }
  },
  // end soundMeasurementRoutes

  //  Admin Management
  {
    path: '/agra/admin/survey',
    name: 'agraAdminSurvey',
    component: () => import('@/views/agra/AdminSurvey.vue'),
    meta: { layout: 'app', sidebar: false, footer: false, authorize: ['admin'] }
  },
  {
    path: '/agra/admin/screenmanagement',
    name: 'screenManagement',
    component: () => import('@/views/agra/admin/ScreenManagement.vue'),
    meta: { layout: 'app', sidebar: false, footer: false, authorize: ['admin'] }
  },
  {
    path: '/agra/admin/organizemanagement',
    name: 'organizeManagement',
    component: () => import('@/views/agra/admin/OrganizeManagement.vue'),
    meta: { layout: 'app', sidebar: false, footer: false, authorize: ['admin'] }
  },
  {
    path: '/agra/admin/usermanagement',
    name: 'userManagement',
    component: () => import('@/views/agra/admin/UserManagement.vue'),
    meta: { layout: 'app', sidebar: false, footer: false, authorize: ['admin'] }
  },
  {
    path: '/agra/admin/useroforganize/:id',
    name: 'userOfOrganize',
    props: true,
    component: () => import('@/views/agra/admin/UserOfOrganize.vue'),
    meta: { layout: 'app', sidebar: false, footer: false, authorize: ['admin'] }
  },
  // end Management

  // envheavy metal
  {
    path: '/agra/envheavymetal/survey/:refId?/:mode?',
    name: 'agraEnvHeavyMetalSurvey',
    props: true,
    component: () => import('@/views/agra/survey/envHeavyMetal/EnvHeavyMetalSurvey.vue'),
    meta: { layout: 'app', sidebar: false, footer: false, authorize: ['member', 'admin'], systemName: 'agra', screenId: [utils.screenId.agraEnvHeavyMetalSurvey, utils.screenId.agraEnvHeavyMetalSurveyAdmin], permissionKey: ['isEdit'] }
  },
  {
    path: '/agra/envheavymetal/list',
    name: 'agraEnvHeavyMetalList',
    props: true,
    component: () => import('@/views/agra/survey/envHeavyMetal/EnvHeavyMetalList.vue'),
    meta: { layout: 'app', sidebar: false, footer: false, authorize: ['admin'], systemName: 'agra', screenId: [utils.screenId.agraEnvHeavyMetalSurveyAdmin], permissionKey: ['isView'] }
  },
  {
    path: '/agra/envheavymetal/mylist',
    name: 'agraEnvHeavyMetalMyList',
    props: true,
    component: () => import('@/views/agra/survey/envHeavyMetal/EnvHeavyMetalMyList.vue'),
    meta: { layout: 'app', sidebar: false, footer: false, authorize: ['member', 'admin'], systemName: 'agra', screenId: [utils.screenId.agraEnvHeavyMetalSurvey], permissionKey: ['isEdit'] }
  },
  {
    path: '/agra/envheavymetal/map',
    name: 'agraEnvHeavyMetalMap',
    component: () => import('@/views/agra/survey/envHeavyMetal/EnvHeavyMetalMap.vue'),
    meta: { layout: 'app', sidebar: false, footer: false, authorize: ['member', 'admin'], systemName: 'agra', screenId: [utils.screenId.agraEnvHeavyMetalSurvey, utils.screenId.agraEnvHeavyMetalSurveyAdmin], permissionKey: ['isView'] }
  },

  // researcher
  {
    path: '/agra/envheavymetal/researcher/list',
    name: 'agraEnvHeavyMetalResearchList',
    component: () => import('@/views/agra/survey/envHeavyMetal/researcher/EnvHeavyMetalList.vue'),
    meta: { layout: 'app', sidebar: false, footer: false, authorize: ['admin', 'member'], systemName: 'agra', screenId: [utils.screenId.agraEnvHeavyMetalSurveyResearcherAdmin], permissionKey: ['isView'] }
  },
  // end envheavy metal

  {
    path: '/agra/manual',
    name: 'agraManual',
    component: () => import('@/views/agra/manual/Manual.vue'),
    meta: { layout: 'app', sidebar: false, footer: false }
  },
  {
    path: '/agra/goldminelayer',
    name: 'goldmineLayer',
    component: () => import('@/views/agra/GoldmineLayerMap.vue'),
    meta: { layout: 'app', sidebar: false, footer: false, authorize: ['member', 'admin'] }
  }
];

export default agraRoutes.map(route => ({
  ...route,
  meta: route.meta.authorize
    ? { ...route.meta, requiredSubId: 1, loginPath: '/agra/login' }
    : route.meta
}));
